import { render } from "./sollictationStats.vue?vue&type=template&id=07248452&scoped=true"
import script from "./sollictationStats.vue?vue&type=script&lang=js"
export * from "./sollictationStats.vue?vue&type=script&lang=js"

import "./sollictationStats.vue?vue&type=style&index=0&id=07248452&scoped=true&lang=css"

import exportComponent from "/usr/src/old_admin_etchite_latest_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07248452"]])

export default __exports__